import { searchStock, refetchStock } from "src/apis/stockApi";
import { PDA1060_R01Dto, PDA1060_R01SearchParams } from "src/containers/PDA/PDA1060_R01/PDA1060_R01Dto";
import usePDA1060_R01Store from "./usePDA1060_R01Store";
import { useToast } from "src/hooks/useToast";

const PDA1060_R01Content = () => {
  const {
    searchParams,
    stockList,
    setStockList,
    setLoading,
    updateSearchParam,
    setDisplayInfo,
  } = usePDA1060_R01Store();
  const { showToast } = useToast();

  const handleSearch = async (scannedValue?: string) => {
    try {
      setLoading(true);

      const params: PDA1060_R01SearchParams = {};
      let scannedLotNo = "";

      if (scannedValue) {
        const trimmedValue = scannedValue.trim().toUpperCase();
        scannedLotNo = trimmedValue;
        params.scanValue = trimmedValue;
        updateSearchParam("scanValue", trimmedValue);
      } else if (searchParams.scanValue) {
        params.scanValue = searchParams.scanValue;
        scannedLotNo = searchParams.scanValue;
      }

      if (searchParams.logicCenter) {
        params.logicCenter = searchParams.logicCenter;
      }
      if (searchParams.warehouseCd) {
        params.warehouseCd = searchParams.warehouseCd;
      }

      const response = await searchStock(params);
      const data = response?.data?.data || [];
      setStockList(data);

      if (data.length > 0) {
        const firstItem = data[0];
        setDisplayInfo({
          itemCd: (firstItem.resultItemCd ?? firstItem.itemCd) ?? "",
          itemNm: firstItem.itemNm ?? "",
          itemSpec: firstItem.itemSpec ?? "",
          modelNo: firstItem.modelNo ?? "",
          unit: firstItem.unit ?? "",
          itemStatus: firstItem.itemStatus ?? "",
          warehouseNm: firstItem.warehouseNm ?? "",
          locationCd: firstItem.locationNm ?? firstItem.locationCd ?? "",
          stockQty: firstItem.stockQty ?? null,
          lotNo: scannedLotNo || (firstItem.lotNo ?? ""),
        });
      } else {
        setDisplayInfo({
          itemCd: "",
          itemNm: "",
          itemSpec: "",
          modelNo: "",
          unit: "",
          itemStatus: "",
          warehouseNm: "",
          locationCd: "",
          stockQty: null,
          lotNo: scannedLotNo,
        });
        showToast("warning", "검색 결과가 없습니다.");
      }
    } catch (error) {
      console.error("재고 조회 실패:", error);
      setStockList([]);
      setDisplayInfo({
        itemCd: "",
        itemNm: "",
        itemSpec: "",
        modelNo: "",
        unit: "",
        itemStatus: "",
        warehouseNm: "",
        locationCd: "",
        stockQty: null,
        lotNo: "",
      });
      showToast("error", "재고 조회에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const handleRefetch = async () => {
    try {
      setLoading(true);

      const params: PDA1060_R01SearchParams = {};
      if (searchParams.scanValue) params.scanValue = searchParams.scanValue;
      if (searchParams.logicCenter) params.logicCenter = searchParams.logicCenter;
      if (searchParams.warehouseCd) params.warehouseCd = searchParams.warehouseCd;

      const response = await refetchStock(params);
      const data = response?.data?.data || [];
      setStockList(data);

      if (data.length > 0) {
        const firstItem = data[0];
        setDisplayInfo({
          itemCd: (firstItem.resultItemCd ?? firstItem.itemCd) ?? "",
          itemNm: firstItem.itemNm ?? "",
          itemSpec: firstItem.itemSpec ?? "",
          modelNo: firstItem.modelNo ?? "",
          unit: firstItem.unit ?? "",
          itemStatus: firstItem.itemStatus ?? "",
          warehouseNm: firstItem.warehouseNm ?? "",
          locationCd: firstItem.locationNm ?? firstItem.locationCd ?? "",
          stockQty: firstItem.stockQty ?? null,
          lotNo: firstItem.lotNo ?? "",
        });
      }
    } catch (error) {
      console.error("재조회 실패:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    handleSearch,
    handleRefetch,
  };
};

export default PDA1060_R01Content;
